const meetingHistoryApis = {
  new_meeting: 'api/potential-candidate-handbook/new-meeting',
  get_meeting_history: 'api/potential-candidate-handbook/get-meeting-history',
};

export default meetingHistoryApis;
